import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const salesTargetDetailsTodo = createAsyncThunk('salesTargetDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `sales-person-target/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const salesTargetDetailsSlice = createSlice({
    name: 'salesTargetDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(salesTargetDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(salesTargetDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default salesTargetDetailsSlice.reducer; 